import { render, staticRenderFns } from "./VehicleProfilePage.vue?vue&type=template&id=0465c9e8&scoped=true&"
import script from "./VehicleProfilePage.vue?vue&type=script&lang=js&"
export * from "./VehicleProfilePage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0465c9e8",
  null
  
)

export default component.exports